<template>
  <div v-if="$store.state.user.registerSuccess && memberInfo && memberInfo.member_type !== 3" class="popup-wrap popup-loigin-event" :class="{ active: $store.state.user.registerSuccess }">
    <div class="popup-box">
      <a class="popup-close" @click="hideModal"><i class="fa-solid fa-xmark" /></a>
      <div class="content">
        <div class="event-main-title">
          {{ $t("Bao.register_title") }}
        </div>
        <div class="FastRegister">
          <div class="item" @click="goPage('/user/friend')">
            <a class="item-frame">
              <div class="item2 p16">
                <p>
                  {{ $t("Bao.register_content_1") }}<br>
                  {{ $t("Bao.register_content_2") }}
                </p>
              </div>
              <button class="item3">{{ $t("Bao.register_btn_1") }}</button>
            </a>
          </div>

          <div class="item" @click="goPage('/deposit')">
            <a class="item-frame">
              <div class="item2 p16">
                <p>
                  {{ $t("Bao.register_content_3") }}<br>
                  {{ $t("Bao.register_content_4") }}!
                </p>
              </div>
              <button class="item3">{{ $t("Bao.register_btn_2") }}</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    memberInfo() {
      return this.$store.state.user.memberInfo
    }
  },
  methods: {
    goPage(route) {
      this.$router.push(route)
      this.$store.commit('SET_REGISTER_SUCCESS', false)
    },
    hideModal() {
      this.$store.commit('SET_REGISTER_SUCCESS', false)

      if (this.$route.name !== 'home') {
        this.$router.push('/')
      }
    }
  }
}
</script>
